import { render } from "./PrivateRows.vue?vue&type=template&id=0472d794&scoped=true"
import script from "./PrivateRows.vue?vue&type=script&lang=js"
export * from "./PrivateRows.vue?vue&type=script&lang=js"

import "./PrivateRows.vue?vue&type=style&index=0&id=0472d794&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0472d794"],['__file',"src/views/overlatelser/OvApplicationView/PrivateRows.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0472d794"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0472d794', __exports__)) {
    api.reload('0472d794', __exports__)
  }
  
  module.hot.accept("./PrivateRows.vue?vue&type=template&id=0472d794&scoped=true", () => {
    api.rerender('0472d794', render)
  })

}


export default __exports__